"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagination = usePagination;
const vue_1 = require("vue");
//IWrappedPropertyArray<ItemType = any, ModelItemType = any
function usePagination(arr, pageSize = 25) {
    /**
     * liczba elmentów na stronie
     */
    const _pageSize = (0, vue_1.ref)(pageSize);
    const _pageNumber = (0, vue_1.ref)(0);
    /**
     * liczba stron
     */
    const pageCount = (0, vue_1.computed)(() => {
        return Math.ceil(arr.$model.length / _pageSize.value);
    });
    /**
     * bieżące sortowanie
     */
    const order = (0, vue_1.ref)('');
    /**
     * bieżący numer strony
     */
    const pageNumber = (0, vue_1.computed)({
        get: () => {
            if (pageCount.value == 0)
                return 0;
            if (_pageNumber.value >= pageCount.value)
                return pageCount.value - 1;
            return _pageNumber.value;
        },
        set: (newValue) => {
            if (newValue <= 0) {
                _pageNumber.value = 0;
            }
            else if (newValue >= pageCount.value) {
                _pageNumber.value = pageCount.value - 1;
            }
            else {
                _pageNumber.value = newValue;
            }
        }
    });
    /**
     * dodaje wiersz, jeśli jest potrzeba to zmienia stronę na ostatnią
     * @param data
     * @returns
     */
    function addRow(data) {
        let res;
        if (data) {
            res = arr.$addRow(data);
        }
        else {
            res = arr.$addRow();
        }
        pageNumber.value = pageCount.value - 1;
        return res;
    }
    /**
     * usuwa wiersz, jeśli jest potrzeba to zmienia stronę
     * @param index
     */
    function removeRow(index) {
        arr.$removeRow(index);
    }
    /**
     * przesuwa wskazany element w górę, jeśli potrzeba to zmienia stronę
     * @param index
     * @returns
     */
    function moveUp(index) {
        if (arr.$exchangeRow(index, index - 1)) {
            gotoItem(index - 1);
            return true;
        }
    }
    /**
     * przesuwa wskazany element w dół, jeśli trzeba zmienia stronę
     * @param index
     * @returns
     */
    function moveDown(index) {
        if (arr.$exchangeRow(index, index + 1)) {
            gotoItem(index + 1);
            return true;
        }
    }
    /**
     * zmienia stronę tak aby był widoczny element
     * @param itemIndex
     */
    function gotoItem(itemIndex) {
        pageNumber.value = Math.floor(itemIndex / _pageSize.value);
    }
    /**
     * zwraca elementy z bieżącej strony
     */
    const items = (0, vue_1.computed)(() => {
        return arr.$getItems(pageNumber.value * _pageSize.value, _pageSize.value, order.value);
    });
    return {
        gotoItem,
        addRow,
        removeRow,
        moveUp,
        moveDown,
        /**
         * liczba elmentów na stronie
         */
        pageSize: _pageSize,
        pageNumber,
        pageCount,
        items,
        order
    };
}
//# sourceMappingURL=usePagination.js.map